module.exports = __webpack_public_path__ + "static/media/page-arrow-r.2c358ccb.svg";